﻿import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {Profile} from "../profile.model";

export interface IdMailResponse { IDSent: boolean }

@Injectable()
export class RegistrationService {
    result: Object;
    error: Object;
    loginObj: Object;
    // token: string;           not needed as always passed in
    // user_id: string;
    // password: string;
    
    
    constructor(public http: HttpClient) {          //, public Jsonp: Jsonp
    }
    
    registerUser(user) {
        console.log('registering user started');
        // var headers = new HttpHeaders();
        // headers.append('Content-Type', 'application/json')
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json'
            })
        };
        var body = JSON.stringify(user);
        const url = '/api/users/'
        return this.http.post(url, body, httpOptions)
    }

    loginUser(value) {
        console.log('login page: Post');
        const httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'})};
        const body = "username=" + value.username + "&password=" + value.password;
        const body2 = "username=" + value.username;
        const url = '/auth/login/'
        return this.http.post(url, body, httpOptions)
            .map((data : any) => {//this only runs if you get the actual data and not on error
                localStorage.setItem('token', data.token);
                localStorage.setItem('user_id', data.user_id);
                localStorage.setItem('password', data.password);
                console.log("data.token: " + data.token)
                let authToken = data.token + ':' + data.password;
                httpOptions.headers = httpOptions.headers.set('Authorization',  'Bearer ' + authToken);
                return data;
            })
            .flatMap((res) => // here we make another call to server to check if user has ever logged in and
                //ensure we log that user has logged. The status of this call is basis for what page they see when logging in.
                    this.http.post('/api/trackLogin/', body2, httpOptions).map((res : any) => {
                    let data = res;
                    return data;
                        }));
    }
    
    retrievePW(value) {
        console.log('password page: Post');
        const httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'})};
        var body = "email=" + value.email;
        return this.http.post('/auth/forgot-password/', body, httpOptions)
    }

    retrieveID(value):Observable<IdMailResponse> {
        console.log('username page: Post');
        const httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'})};
        var body = "email=" + value.email;
        return this.http.post<IdMailResponse>('/api/email-username', body, httpOptions)
    }
    
    changePW(value) {
        console.log('password reset page: Post');
        const httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'})};
        var body = "token=" +value.token + "&password=" + value.password  + "&confirmPassword=" + value.confirmPassword;
        return this.http.post('/auth/password-reset/', body, httpOptions)
    }
    
    logout(token, password) {//have to pass in token and password as this object looses references when moving around app
        
        console.log('logout initiated'); 
        var body = '';
        let authToken = token + ':' + password;
        const httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + authToken})};
        return this.http.post('/auth/logout/', body, httpOptions)
            .map((res : any) => {
                localStorage.removeItem('token');
                localStorage.removeItem('password');
                localStorage.removeItem('user_id');
            });
            //.map(res => res.json());         
    }
        
     
    //currently not used but can be used to get roles (authservice now handles checking if user is logged in)
    getSession(token, password) {
        console.log('getSession: Get Data');
        const httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'})};
        let authToken = token + ':' + password;
        httpOptions.headers = httpOptions.headers.set('Authorization',  'Bearer ' + authToken);
        return this.http.get('/auth/session/', httpOptions)
    }
      
    usernameCheck(username) {
        console.log('emailCheck: Get Data');
        const httpOptions = {headers: new HttpHeaders({'Content-Type':  'application/json'})};
        let profile:Profile = <Profile>{}
        profile.username = username;
        const body = JSON.stringify(profile)
        console.log('body: ' + body)
        const url = '/api/check-username/'
        return this.http.post<Profile>(url, body, httpOptions)
    }
    
    urlCheck(url) {
        console.log('urlCheck: Get Data');
        const httpOptions = {headers: new HttpHeaders({'Content-Type':  'application/json'})};
        return this.http.post('/api/check-url/', `{"url": "${url}"}`, httpOptions)
    }
    
    emailCheck(email) {//SEEMS WE HAVE TO CHECK EMAIL AS WELL AS SUPERLOGIN FAILS IF USER HAS USED EMAIL BEFORE IT SEEMS JW

        console.log('emailCheck: Get Data');
        const httpOptions = {headers: new HttpHeaders({'Content-Type':  'application/json'})};
        let profile:Profile = <Profile>{}
        profile.email = email;
        const body = JSON.stringify(profile)
        // console.log('body: ' + body)
        const url = '/api/check-email/'
        return this.http.post<Profile>(url, body, httpOptions)
    }

}


